import { Link } from "react-router";
import { contact } from "~/src/data/contact";
import * as styles from "./Contact.module.css";

const contactCards = contact.map((i) => (
  <Link
    className={styles.link}
    to={i.link}
    target="_blank"
    rel="noopener"
    key={crypto.randomUUID()}
  >
    <span className={`${styles[`${i.name}Icon`.replace(/\(|\)|\s/g, "")]}`}>
      {i.icon}
    </span>
    <h3 className={`${styles[`${i.name}Icon`.replace(/\(|\)|\s/g, "")]}`}>
      {i.name}
    </h3>
  </Link>
));

export default function Contact() {
  return (
    <section className={styles.contactSection}>
      <h2 id="contact" className={styles.heading}>
        Let's Work Together
      </h2>
      <div className={styles.cardsContainer}>{contactCards}</div>
    </section>
  );
}
